var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5533 9.40015C11.6572 9.50103 11.7937 9.55156 11.9302 9.55156C12.0658 9.55156 12.2015 9.50175 12.3052 9.40195C12.9926 8.74114 13.3711 7.86011 13.3711 6.9212C13.3711 5.98371 12.9939 5.10305 12.3089 4.44137C12.1012 4.24087 11.7646 4.24087 11.5569 4.44155C11.3493 4.64223 11.3493 4.96745 11.557 5.16813C12.0411 5.63559 12.3077 6.25828 12.3077 6.92124C12.3077 7.58475 12.0405 8.20703 11.5551 8.6738C11.3469 8.87395 11.3461 9.19915 11.5533 9.4002L11.5533 9.40015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9026 7.03048C14.9026 8.39205 14.338 9.67462 13.3128 10.6416C13.0985 10.8438 13.0989 11.1711 13.3138 11.3729C13.4211 11.4736 13.5614 11.5239 13.7019 11.5239C13.8427 11.5239 13.9836 11.4732 14.0909 11.372C15.3231 10.2097 16.0018 8.66782 16.0018 7.0305C16.0018 5.39318 15.3231 3.85129 14.0909 2.68898C13.8767 2.48682 13.5288 2.48646 13.3137 2.68808C13.0989 2.88988 13.0985 3.2172 13.3128 3.41937C14.3382 4.38634 14.9026 5.66892 14.9026 7.03048Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.704634 10.0674H4.02866C4.17083 10.0674 4.30952 10.1103 4.42671 10.1903L8.76085 13.1509C9.2285 13.4703 9.86352 13.1363 9.86352 12.5709V1.4854C9.86352 0.920094 9.22836 0.585937 8.76085 0.905384L4.42671 3.86596C4.30952 3.94597 4.17064 3.98887 4.02866 3.98887H0.704634C0.315513 3.98887 0 4.3036 0 4.69181V9.3646C0 9.75278 0.31549 10.0675 0.704634 10.0675V10.0674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUpIcon);
export default __webpack_public_path__ + "static/media/volume-up-icon.e8453b93ca8c080d9bd6d348f489f6d3.svg";
export { ForwardRef as ReactComponent };